module.exports = __webpack_public_path__ + "img/aron.3d49ceb1.jpg";